import Configuration from '@gatec/core/config';

export const Config : Configuration.Model = {
  application: {
    id: 1,
    key: 'app.name',
  },
};
